import { useCallback, useMemo } from 'react'
import moment from 'moment'
import { dataUnready } from '~/lib/helpers/dataUnready'
import { formatAlert } from '~/lib/helpers/formatAlert'
import PropTypes from 'prop-types'

function AlertsItem ({ alert, handleAlertClick, tag: Tag }) {
  const formattedAlert = useMemo(() => formatAlert(alert, alert.alertModel), [alert])

  const handleClick = useCallback(() => {
    handleAlertClick(formattedAlert.url, formattedAlert)
  }, [alert, handleAlertClick])

  return (
    <Tag title={formattedAlert.title} handleClick={handleClick} fromNow={moment(formattedAlert.createdAt).fromNow()} />
  )
}

AlertsItem.propTypes = {
  alert: PropTypes.object.isRequired,
  handleAlertClick: PropTypes.func,
  tag: PropTypes.func
}

function AlertsList ({ alerts, handleAlertClick, tag }) {
  let renderedAlerts = null

  if (alerts && alerts.length) {
    renderedAlerts = alerts.map(alert => {
      return <AlertsItem key={alert.id} alert={alert} handleAlertClick={handleAlertClick} tag={tag} />
    })
  }

  return renderedAlerts
}

AlertsList.propTypes = {
  alert: PropTypes.object,
  handleAlertClick: PropTypes.func,
  tag: PropTypes.func
}

function CustomAlerts ({ data, tag, handleAlertClick }) {
  const { unready, alerts } = dataUnready(data, 'alerts')
  let results = null

  if (!unready) {
    results = <AlertsList alerts={alerts} handleAlertClick={handleAlertClick} tag={tag} />
  }

  return results
}

CustomAlerts.propTypes = {
  data: PropTypes.object,
  tag: PropTypes.func,
  handleAlertClick: PropTypes.func
}

export default CustomAlerts
